export default __webpack_public_path__ + "static/media/Guru-Parampara-19.e9a5e9e8.png";